import subscription from "../apis/api";
import { SUBSCRIBE_REQUEST, SUBSCRIBE_SUCCESS, SUBSCRIBE_FAIL } from "./types";
import { errorHandler } from "../Utils/errorHandling";
import { configUtil } from "../Utils/apiConfig";

export const subscribeUser = (email) => async (dispatch, getState) => {
  const { userInfo } = getState().userAuth;
  try {
    dispatch({ type: SUBSCRIBE_REQUEST });
    console.log("subemail", email);
    const { data } = await subscription.post(
      "/subscription",
      { email },
      configUtil(userInfo.token)
    );

    console.log("subemail__ created", data);

    dispatch({ type: SUBSCRIBE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: SUBSCRIBE_FAIL, payload: errorHandler(error) });
  }
};
